import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {LovListSummary} from "../LovListSummary.model";
import {LovListModelConverter} from "./lovListModel.converter";

export class LovListSummaryConverter extends HttpModelConverter<LovListSummary> {

    protected createInstance(): LovListSummary {
        return new LovListSummary();
    }

    protected enrichObject(result: LovListSummary, src: LovListSummary) {
        result.model = new LovListModelConverter().convert(src.model);
    }
}